// extracted by mini-css-extract-plugin
export default {"root":"W7EMjvV7vJC4X0B6v34c","title":"QCsxMdHdZZcexMdIOG48","lock":"oU_LCztfasdk1_5_YcUg"};